















































































helpers = require('../../helpers.coffee')

view_model =
  components:
    contactList: require('../contacts/list')
    createTagModal: require('../contacts/create_tag_modal')
    reactivateRecipientModal: require('../automatic_tasks/reactivate_recipient_modal')
    changeResponsabilityModal: require('../contacts/change_responsability_modal')
    taskModalForm: require('../manual_tasks/modal_form')

  data: ->
    schedule_reactivation_contact: null
    selected_all: false
    selected_contact: {}
    selected_contacts: []
    unselected_contacts: []
    current_user: Session.current_user
    filters: {}
    fetching: false
    next_page: true
    total_count: 0
    contacts: []

  computed:
    count_selected_contacts: ->
      if @selected_all
        @count_all_contacts - @unselected_contact_ids.length
      else
        @selected_contact_ids.length

    count_all_contacts: ->
      @total_count

    count_page_contacts: ->
      @contacts.length

    selected_contact_ids: ->
      @selected_contacts.map (contact) -> contact.id

    unselected_contact_ids: ->
      @unselected_contacts.map (contact) -> contact.id

  methods:
    #Routing
    leadsRedirect: ->
      @$router.push '/contatos/leads'

    businessRedirect: ->
      @$router.push '/contatos/empresas'

    groupsRedirect: ->
      @$router.push '/contatos/grupos'

    openDestroyContactConfirmationModal: (data) ->
      @selected_contact = data.contact
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-remove-contact'

    callDestroyContact: ->
      @destroyContact(contact: @selected_contact, @contact_resource)

    callDestroyContacts: ->
      params =
        type:           'destroy'
        filters:        @filters
        selected_ids:   @selected_contact_ids
        unselected_ids: @unselected_contact_ids

      @contact_resource.massActionExecute @destroyContactsSuccess, @unknownError, params

    destroyContactsSuccess: (response) ->
      alertify.success 'Contatos removidos com sucesso!'
      @excludeContactsFromList(response.body.contact_ids)
      @selected_contacts = []

    selectedAll: (data) ->
      @selected_all = data.selected_all
      if @selected_all
        @selected_contacts = []
      else
        @unselected_contacts = []

    massActionUpdateContactTag: (data) ->
      @updateContactTag(@contacts, data.contact_ids, data.change_tags)
      @clearSelections()
      Loader.off()

    excludeContactsFromList: (contact_ids) ->
     size = @contacts.length - 1
     for idx in [size..0] when contact_ids.indexOf(@contacts[idx].id) > -1
       @contacts.splice(idx, 1)

    changeResponsabilityParams: (data) ->
      params =
        type: 'change_responsability'
        filters: @filters
        selected_ids: @selected_contact_ids
        unselected_ids: @unselected_contact_ids
        to_user_id: data.user.id
        finish_transfer: data.flag_finish
      params

    callPrepareChangeResponsability: (data) ->
      Loader.on()
      params = @changeResponsabilityParams(data)
      @user_selected = data.user
      @contact_resource.massActionPrepare @prepareSuccess, @prepareFail, params

    prepareSuccess: (response) ->
      EventsBus.$emit 'confirm-modal-show', { id: 'change-responsability', user: @user_selected, data: response.data  } unless @disabled_buttons
      Loader.off()

    confirmChangeResponsability: (data) ->
      Loader.on()
      params = @changeResponsabilityParams(data)
      @contact_resource.massActionExecute @confirmChangeResponsabilitySuccess, @unknownError, params

    confirmChangeResponsabilitySuccess: (response) ->
      alertify.success 'Transferência realizada. A atualização dessa mudança na base pode demorar alguns minutos.'
      @updateContactResponsible(@selected_contacts, @user_selected, response.data.contact_ids)
      @clearSelections()
      Loader.off()

    addContactList: (list, contact) ->
      idx = list.indexOf(contact)
      list.push(contact) if idx == -1

    delContactList: (list, contact) ->
      idx = list.indexOf(contact)
      list.splice(idx, 1)

    loadSelectedContactsList: (data) ->
      if @selected_all
        if data.attr.selected
          @delContactList(@unselected_contacts, data.attr.contact)
        else
          @addContactList(@unselected_contacts, data.attr.contact)

      if !@selected_all
        if data.attr.selected
          @addContactList(@selected_contacts, data.attr.contact)
        else
          @delContactList(@selected_contacts, data.attr.contact)

    clearSelections: ->
      @selected_all        = false
      @selected_contacts   = []
      @unselected_contacts = []
      EventsBus.$emit 'ContactList:ClearSelections', { @selected_all }

    filter: (filters) ->
      @filters = filters
      @contacts = []
      @next_page = 1
      @clearSelections()
      @loadData()

    loadData: ->
      return if @fetching || !@next_page
      @fetching = true
      @contact_resource.index @loadSuccess, @unknownError,params: {q: @filters, page: @next_page}

    loadSuccess: (resources) ->
      @fetching = false
      @next_page = resources.meta.next_page
      @total_count = resources.meta.total_count
      @contacts = @contacts.concat(resources.contacts)
      Loader.off()

    setFiltersFromQueryParamsLocal: ->
      query    = Object.assign({}, @$router.currentRoute.query)
      @filters = query
      @filters['with_tags'] = @filters['with_tags[]'] if @filters['with_tags[]']
      @filters['id_in'] = @filters['id_in'].split(',') if @filters['id_in']

    exportContacts: (type) ->
      Loader.on()
      @contact_resource.export @loadSuccessExport, @unknownError, {q: @filters, type_export: type}

    loadSuccessExport: (resources) ->
      Loader.off()
      return alertify.success(resources.data.message) if resources.data.message
      rows = resources.data.csv.split('\n')
      csvContent = rows.join("\n");
      link = document.createElement("a");
      link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent('\uFEFF'+csvContent));
      link.setAttribute("download", "contatos.csv");
      document.body.appendChild(link);
      link.click();

  watch:
    '$route': ->
      @setFiltersFromQueryParamsLocal()
      @$emit('updateClearFilter')
      @filter(@filters)

  created: ->
    @contact_resource = new ContactsResource Session.current_company.id
    @setFiltersFromQueryParamsLocal()
    @loadData()

    EventsBus.$on 'Contact::ScheduleRecipientReactivation', @openRecipientScheduleReactivationModal
    EventsBus.$on 'Contact::Refresh', @refreshContact
    EventsBus.$on 'ContactList:SelectedAll', @selectedAll
    EventsBus.$on 'MassActions:Tags:UpdateContacts', @massActionUpdateContactTag
    EventsBus.$on 'Show::UpdateListContactsInfo', @updateContactList

  beforeDestroy: ->
    EventsBus.$off 'Contact::ScheduleRecipientReactivation', @openRecipientScheduleReactivationModal
    EventsBus.$off 'Contact::Refresh', @refreshContact
    EventsBus.$off 'ContactList:SelectedAll', @selectedAll
    EventsBus.$off 'MassActions:Tags:UpdateContacts', @massActionUpdateContactTag
    EventsBus.$off 'Show::UpdateListContactsInfo', @updateContactList

exports.default = helpers.vue_include(view_model, helpers.form,
                                                  helpers.contacts.list_view_modes, helpers.contacts.list_wrapper,
                                                  helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/leads.vue